export function capitalizeFirstLetter(string: string) {
  if (!string) return ""; // Handle undefined or empty string
  return string.charAt(0).toUpperCase() + string.slice(1);
}
